import React from "react";
import classNames from "classnames";
import useScreenResolution from "../../core/hooks/useScreenResolution";
import DashboardUddannelseslaeger from "./dashboardUddannelseslaeger/dashboardUddannelseslaeger";
import DashboardOpmaerksomhedspunkter from "./dashboardOpmaerksomhedspunkter/dashboardOpmaerksomhedspunkter";
import DashboardKompetencer from "./dashboardKompetencer/dashboardKompetencer";
import DashboardVejledersamtaler from "./dashboardVejledersamtaler/dashboardVejledersamtaler";
import DashboardUddannelsesplaner from "./dashboardUddannelsesplaner/dashboardUddannelsesplaner";

export const DashboardOverview = () => {
    const {isMobile} = useScreenResolution();

    return (
        <>
            <div className={classNames(!isMobile && "flex-container-row flex-space-between")}>
                <DashboardUddannelseslaeger/>
                <DashboardOpmaerksomhedspunkter/>
            </div>
            <DashboardKompetencer/>
            <DashboardVejledersamtaler/>
            <DashboardUddannelsesplaner/>
        </>
    );
}
